module.exports = __webpack_public_path__ + "static/media/auditorium.51e03c05.jpg";